import Notices from "./Notices";
import AjaxBlocking from "./AjaxBlocking";
import $ from "jquery";
export default class WooCommerceCart {
    constructor() {
        this.body = document.body;

        this.cartPage = document.querySelector("div.cart-page");
        this.isCartPage = !!this.cartPage;

        this.checkoutPage = document.querySelector("div.checkout__wrap");
        this.isCheckoutPage = !!this.checkoutPage;

        this.couponsEl = document.getElementById("js-mini-cart-coupon");
        this.couponAccordion = document.querySelector(
            ".cart-sidebar__discount"
        );

        this.events();
    }

    events() {
        // Coupons
        this.coupons();

        // Quantity func
        document.body.addEventListener("click", (e) => {
            if (
                e.target.classList.contains("quantity-plus") ||
                e.target.classList.contains("quantity-plus-icon")
            ) {
                this.changePlusQty(e.target);
            }
        });

        document.body.addEventListener("click", (e) => {
            if (
                e.target.classList.contains("quantity-minus") ||
                e.target.classList.contains("quantity-minus-icon")
            ) {
                this.changeMinusQty(e.target);
            }
        });

        document.body.addEventListener("keyup", (e) => {
            if (e.target.classList.contains("qty")) {
                this.changeQty(e.target);
            }
        });

        // Stop scrolling page after update cart
        jQuery(document).ready(function ($) {
            $(document).ajaxComplete(function () {
                if ( $("body").hasClass("woocommerce-cart") ) {
                    jQuery("html, body").stop();
                }

                if (!document.body.classList.contains("woocommerce-checkout") && !document.body.classList.contains("woocommerce-cart")) {
                    const qty =
                        document.querySelector(".mini-cart__count").innerHTML;

                    if (parseInt(qty) > 0) {
                        if (!document.body.classList.contains("has_items")) {
                            document.body.classList.add("has_items");
                        }
                    } else {
                        document.body.classList.remove("has_items");
                    }
                }
            });
        });
    }

    changeQty(el) {
        let newVal = parseInt(el.value, 10);
        const maxVal = parseInt(el.max, 10);
        const minVal = 1;

        // eslint-disable-next-line eqeqeq
        if (!newVal && newVal != 0) {
            return;
        }

        if (newVal === 0) {
            newVal = 1;
        }

        if (!maxVal || (maxVal && newVal < maxVal)) {
            el.value = newVal;
        } else {
            setTimeout(() => {
                el.value = maxVal;
            }, 500);
        }

        if ((!minVal && newVal >= 1) || (minVal && minVal <= newVal)) {
            el.value = newVal;
        } else if (minVal && minVal > newVal) {
            el.value = minVal;
        } else {
            el.value = newVal;
        }

        if (!isNaN(newVal)) {
            el.value = newVal === 0 ? 1 : Math.abs(newVal);
            // eslint-disable-next-line no-self-assign
            el.value = el.value;
        } else {
            // eslint-disable-next-line no-self-assign
            el.value = el.value;
            return;
        }

        let parent = el.closest(".cart-sidebar__product");
        parent = parent || el.closest(".cart-page__product");
        const id = parent.dataset.productId;

        fetch(window.global.ajax_url + "?action=ChangeItemQty", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
            body: new URLSearchParams({
                security: window.global.security,
                id: id,
                qty: newVal,
                isCartPage: this.isCartPage,
            }),
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success) {
                    this.changeQtyTimeout(el, newVal, data.data.wc_notices);
                }
            })
            .catch((err) => {
                console.log(err);
            });

        this.changeQtyTimeout(el, newVal);
    }

    changePlusQty(el) {
        const qty = el.closest("div").children[2];
        const qtyValue = parseInt(qty.value, 10);

        const maxVal = parseInt(qty.max, 10);

        if (!maxVal || (maxVal && qtyValue < maxVal)) {
            qty.value = qtyValue + 1;
        } else {
            qty.value = maxVal;
        }

        this.changeQtyTimeout(el, qty.value);
    }

    changeMinusQty(el) {
        const qty = el.closest("div").children[2];
        const qtyValue = parseInt(qty.value, 10);

        const minVal = parseInt(qty.min, 10);

        if (qtyValue > 1) {
            qty.value = qtyValue - 1;
        } else if (qtyValue === 1 || qtyValue === 0) {
            qty.value = 1;
            return;
        } else {
            qty.value = qtyValue - 1;
            return;
        }

        this.changeQtyTimeout(el, qty.value);
    }

    changeQtyTimeout(element, qty, notice = null) {
        self.timeout = setTimeout(() => {
            this.updateCart();

            const noticesWrapper = document.getElementById(
                "page__notices-wrapper"
            );
            const noticeContainer = document.querySelector(
                ".jsPageNoticeWrapper"
            );

            jQuery(document.body).on("updated_cart_totals", function () {
                // const complaintNotices = new Notices(true);

                if (notice) {
                    noticesWrapper.innerHTML = notice;
                    console.log('notice1');
                }

                if (noticeContainer) {
                    noticeContainer.classList.remove("is-hidden");

                    window.setTimeout(() => {
                        noticeContainer.classList.add("is-hidden");
                    }, 10000);
                }
            });
        }, 500);
    }

    coupons() {
        document.body.addEventListener("click", (e) => {
            if (e.target.classList.contains("couponSubmitJs")) {
                e.preventDefault();
                const code = document.querySelector(
                    ".cart-sidebar__discount-input"
                ).value;
                this.addCouponToCart(code);
            }
        });
    }

    // Add coupon to cart, minicart, checkout
    addCouponToCart(code) {
        const myBlock = new AjaxBlocking();
        const couponBlock = document.getElementById("js-mini-cart-coupon");
        myBlock.blockOnAjax(couponBlock);

        fetch(window.global.ajax_url + "?action=ApplyCoupon", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            redirect: "follow",
            referrerPolicy: "no-referrer",
            body: new URLSearchParams({
                security: window.global.security,
                code: code,
                isCartPage: this.isCartPage,
                isCheckoutPage: this.isCheckoutPage,
            }),
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (this.isCheckoutPage) {
                    $("body").trigger("update_checkout");

                    if (
                        Object.prototype.hasOwnProperty.call(
                            data.data,
                            "wc_notices"
                        )
                    ) {
                        this.displayMiniCartCouponNotice(data.data.wc_notices);
                    }

                    // document.querySelector(
                    //     ".checkout__review__content"
                    // ).innerHTML = data.data.checkout_content;
                } else if (this.isCartPage) {
                    this.updateCart();
                    document
                        .querySelector(".cart-sidebar__discount")
                        .classList.toggle("open");
                } else {
                    if (
                        data.data.message.includes("You can't use this coupon")
                    ) {
                        if (
                            Object.prototype.hasOwnProperty.call(
                                data.data,
                                "wc_notices"
                            )
                        ) {
                            this.displayMiniCartCouponNotice(
                                data.data.wc_notices
                            );
                        }

                        document
                            .querySelector(".cart-sidebar__discount")
                            .classList.toggle("open");

                        const noticeContainer = document.querySelector(
                            ".jsCartSidebarDiscountNotices ul"
                        );

                        if (noticeContainer) {
                            window.setTimeout(() => {
                                noticeContainer.remove();
                            }, 5000);
                        }
                    } else {
                        this.updateCart();

                        if (
                            Object.prototype.hasOwnProperty.call(
                                data.data,
                                "wc_notices"
                            )
                        ) {
                            this.displayMiniCartCouponNotice(
                                data.data.wc_notices
                            );
                        }
                    }
                }

                myBlock.unblockOnAjax(couponBlock);
                this.scrollTopOnChange(true);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    updateCart() {
        const updateBtn = document.querySelector("button[name=update_cart]");

        if (updateBtn) {
            updateBtn.disabled = false;
            self.timeout = setTimeout(() => {
                updateBtn.click();
            }, 500);

            const cartNotices = new Notices();
            cartNotices.hideNotices();

            console.log('notice2');
        }
    }

    scrollTopOnChange(scrollToCoupons = false) {
        const anchor = document.querySelector(".jsCartSidebarStockNotices");
        const coupons = document.querySelector(".jsCartSidebarDiscountNotices");
        const cart_sidebar = document.querySelector(".cart-sidebar");

        if (coupons && scrollToCoupons === true && !this.isCheckoutPage) {
            coupons.scrollIntoView({
                behavior: "smooth",
            });
        }

        if (coupons && scrollToCoupons === true && this.isCheckoutPage) {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }

        if (anchor && scrollToCoupons === false) {
            window.setTimeout(() => {
                cart_sidebar.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            }, 500);
        }

        if (!this.isCartPage) return;

        window.setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }, 500);
    }

    displayMiniCartCouponNotice(message) {
        if (this.isCartPage) return;

        const miniCartNotices = document.querySelector(
            ".jsCartSidebarDiscountNotices"
        );
        if (miniCartNotices) {
            miniCartNotices.innerHTML = message;
        }
        this.scrollTopOnChange(true);
    }
}